import { DEFAULT_ROUTE, BROKER_LOGIN_ROUTE } from "./config";

export const KEYS = {
  //debug
  DEBUG_DEV_MODE: "DEBUG_DEV_MODE",

  //application
  APP_TENANT: "APP_TENANT",
  ENV: "ENV",
  APP_NAME: "APP_NAME",
  APP_API: "APP_API",
  ASSET_URL: "ASSET_URL",
  LOCALE: "LOCALE",
  DOMAIN: "DOMAIN",

  //strapi
  STRAPI_API_URL: "STRAPI_API_URL",
  STRAPI_API_TOKEN: "STRAPI_API_TOKEN",

  //dynamic page
  DYNAMIC_PAGE_SWIPER: "DynamicPageSwiper",

  //frontend api
  PREFERRED_URL: "PREFERRED_URL",

  LOCAL_STORAGE: {
    LOCATION_DATA: "LOCATION_DATA",
    DEVICE_ID: "DEVICE_ID",
    //for broker login value prop/info drawer
    USE_BROKER_INTRO: "USE_BROKER_INTRO",
    NOTIFICATION: "NOTIFICATION",
    NOTIFICATION_COUNTER: "NOTIFICATION_COUNTER",
    PERSISTENT_ID: "PERSISTENT_ID",
    CONVERSION_ID: "CONVERSION_ID",
    CONVERSION_LABEL: "CONVERSION_LABEL",
    SITE_SOURCE: "SITE_SOURCE",
    MARKETING_SOURCE: "MARKETING_SOURCE",
    MARKETING_PHONE_NUMBER: "MARKETING_PHONE_NUMBER",
  },

  SEARCH_PARAM: {
    BROKER_PROFILE: "profile",
  },

  ELEMENT_IDS: {
    FOOTER_PADDING: "footerPadding",
  },
};

export const QUERY_PARAMS = {
  SECTION_SLUG: "section",
  BROKER_PROFILE: KEYS.SEARCH_PARAM.BROKER_PROFILE,
  ACTIVE: "active",
  EXTRA_SECTIONS: "extra-sections",
};

export const PAGE_PATHS = {
  BROKER_DEFAULT_PAGE: "/broker/dashboard",
  BROKER_CONTENT_PAGE: "/broker/content",
  BROKER_PROFILE_PAGE: "/broker/branding",
  BROKER_REFRESH: "/broker/refresh",
  BROKER_LOGIN_ROUTE,
  DEFAULT_ROUTE,
};

export const DOMAIN_PATH_PREFIX = {
  base: "/c",
  flow: "/",
};
